var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import { connect } from "react-redux";
import Loading from "@irati/ui/src/Loading";
import AuthActions from "@irati/auth/store/actions/AuthActions";
import auth from "@irati/auth";
import SideNavigation from "@irati/ui/src/Navigation/SideNavigation";
import getMenuItems from "./menuItems";
var CompanySettingsOptions = /** @class */ (function (_super) {
    __extends(CompanySettingsOptions, _super);
    function CompanySettingsOptions(props) {
        var _this = _super.call(this, props) || this;
        var load = props.updateTenant().then(function (tenant) {
            var imageLink = tenant.imageLink;
            _this.setState({ imageLink: imageLink });
        });
        _this.state = { load: load };
        return _this;
    }
    CompanySettingsOptions.prototype.render = function () {
        var load = this.state.load;
        var children = this.props.children;
        var showSSO = !!auth.apps("admin.sso");
        var permissions = auth.apps();
        var showPerks = permissions.perks;
        var canViewRecognition = !!(permissions.recognition && auth.apps("admin.customPermissions"));
        var menuItems = getMenuItems({ showPerks: showPerks, showRecognition: canViewRecognition, showSSO: showSSO });
        return (React.createElement(Loading, { load: load },
            React.createElement(Row, null,
                React.createElement(Col, { sm: 4, md: 4 },
                    React.createElement(SideNavigation, { links: menuItems })),
                React.createElement(Col, { sm: 8, md: 8 }, children))));
    };
    return CompanySettingsOptions;
}(Component));
export var CompanySettingsOptionsUnconnected = CompanySettingsOptions;
var mapDispatchToProps = function (dispatch) {
    return {
        updateTenant: function () { return dispatch(AuthActions.updateTenant()); }
    };
};
export default connect(null, mapDispatchToProps)(CompanySettingsOptions);
